var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PatientAttentionLevelPopover',{attrs:{"option":_vm.value,"options":_vm.levels,"disabled":!_vm.editable},on:{"levelChange":_vm.handleChange}},[_c('ul',{staticClass:"levels",attrs:{"data-type":_vm.value}},_vm._l((_vm.items),function(active,index){return _c('li',{key:index,class:{ active }})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }